import Admin from '../components/Admin';

export default Admin.compileFromLibrary([
  'GroupResource',
  {
    title: 'Categories',
    icon: 'barcode',
    path: '/categories',
    redirect: [['redirect.unauthorized']],
    filters: [
      ['FilterRegexSearch', {
        id: 'search',
        col: 24,
        paths: ['name', 'type'],
        caseInsensitive: true,
        section: 'top',
      }],
      ['FilterPagination', {
        id: 'pagination',
        section: 'bottom',
      }],
    ],
    archiveConfig: {
      title: 'Categories',
      icon: 'barcode',
      label: 'Categories',
      createButtonPath: '/categories/create',
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/users/me',
        ],
      ],
    },
    singleConfig: {
      hidden: true,
      alias: '/categories',
      headerTitle: 'Create',
      backButtonLabel: 'Close',
      backButtonPaths: ['/categories'],
    },
    singleCreateConfig: {
      hidden: true,
    },
    singleEditConfig: {
      getBackButtonPaths: props => (
          props.viewer && props.viewer.role === 'ADMIN'
        ? props.backButtonPaths
        : false
      ),
      hidden: true,
    },
    columns: [
      { path: 'name', link: '/categories/:_id' },
    ],
    fields: [
      ['FieldText', {
        name: 'name',
        rules: [['validation.isRequired']],
      }],
    ],
  },
]).pages;
